<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="risk-category-view-page-title" class="mb-3">
              {{ riskCategory.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('risk_category')">
                <GuideButton :guide="getGuide('risk_category')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-rc-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.RISK_CATEGORY_EDIT, permissions.RISK_CATEGORY_EDIT_OWN], riskCategory.created_by) && (!getClient.parent || (getClient.parent && riskCategory.partition))"
                      class="btn btn-edit"
                      qid="edit-rc-button"
                      @click="showEditRCModal(riskCategory)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], riskCategory.created_by) && (!getClient.parent || (getClient.parent && riskCategory.partition))"
                      class="btn btn-delete"
                      qid="delete-rc-button"
                      @click="showConfirmDeleteModal(riskCategory)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-rc-modified-date">
              {{ riskCategory.updated_at | formatDate }}
            </span>
              <Avatar v-if="riskCategory.updated_by" :object="riskCategory.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="riskCategory.updated_by" qid="view-rc-modified-by">
              {{ riskCategory.updated_by.name }}
            </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- Basic info tab -->
      <b-tab :title="$t('maintenance.risk_categories.tab.basic_info')" active>
        <div class="card">
          <div class="card-body">
            <div class="content-view-body">
              <br>
              <div class="mt-3">
                <p class="text-dark">
                  {{ $t('maintenance.risk_categories.create.description_label') }}

                </p>
                <hr>
                <p v-if="riskCategory.description"
                   class="text-formatted"
                >
                  {{ riskCategory.description }}
                </p>
                <br>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- Risk profile tab -->
      <b-tab :title="$t('maintenance.risk_categories.tab.risk_profile')">
        <div class="card" qid="risk-tolerance-section">

          <div class="card-header border-bottom-0">
            <div class="row">
              <div class="col-md-6">
              <h4 qid="risk-tolerance-section-title" class="mb-3">
                {{ $t('activities.risk_scenario.inherent_risk.risk_tolerance_label') }}
              </h4>
              </div>
              <div class="col-md-6">
              <b-button
                  @click="showToleranceFormFunction"
                  v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], riskCategory.created_by) && (!getClient.parent || (getClient.parent && riskCategory.partition))"
                  variant="success"
                  class="float-right ml-3"
                  qid="edit-risk-tolerance-button"
              >
                <font-awesome-icon icon="pen"/> {{ $t('maintenance.risk_categories.update.risk_tolerance_button') }}
              </b-button>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="text-center">
                  <h6>{{ $t('risk_scenarios.risk_type.business_risk') }}</h6>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="text-center">
                  <h6>{{ $t('risk_scenarios.risk_type.privacy_risk') }}</h6>
                </div>
              </div>
            </div>
          </div>


          <!-- Single risk tolerance -->
          <!-- _____________________ -->

          <div class="row no-gutters" v-if="getClient.risk_type != 'cia_risk'">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span class="mt-2">{{ $t('activities.risk_scenario.inherent_risk.risk_tolerance_label') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedBusinessToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedBusinessToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory && riskCategory.business_risk_tolerance && riskCategory.business_risk_tolerance.risk != ''">
                    <span :qid="'risk-risk-' + riskCategory.business_risk_tolerance.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.business_risk_tolerance.number"
                        :class="[ riskCategory.business_risk_tolerance.number ? 'risk-'+riskCategory.business_risk_tolerance.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.business_risk_tolerance.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.business_risk_tolerance.risk)) }}
                      </span>
                      <span v-if="riskCategory.business_risk_tolerance.number">
                        ({{riskCategory.business_risk_tolerance.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedPrivacyToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedPrivacyToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory && riskCategory.privacy_risk_tolerance && riskCategory.privacy_risk_tolerance.risk != ''">
                    <span :qid="'risk-risk-' + riskCategory.privacy_risk_tolerance.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.privacy_risk_tolerance.number"
                        :class="[ riskCategory.privacy_risk_tolerance.number ? 'risk-'+riskCategory.privacy_risk_tolerance.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.privacy_risk_tolerance.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.privacy_risk_tolerance.risk)) }}
                      </span>
                      <span v-if="riskCategory.privacy_risk_tolerance.number">
                        ({{riskCategory.privacy_risk_tolerance.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- CIA risk tolerance -->
          <!-- __________________ -->

          <div class="row no-gutters" v-if="getClient.risk_type == 'cia_risk'">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark" :class="{'mt-1': showToleranceRiskForm}">
                <span>
                  {{ $t('validations.checklist.confidentiality') }}
                </span>
              </div>
              <div class="card-body text-dark" :class="{'mt-5': showToleranceRiskForm}">
                <span>
                  {{ $t('validations.checklist.integrity') }}
                </span>
              </div>
              <div class="card-body text-dark" :class="{'mt-5': showToleranceRiskForm}">
                <span>
                  {{ $t('validations.checklist.availability') }}
                </span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedCBusinessToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedCBusinessToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div class="mw-500 mt-3" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedIBusinessToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedIBusinessToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div class="mw-500 mt-3" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedABusinessToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedABusinessToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="business-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory && riskCategory.business_risk_confidentiality && riskCategory.business_risk_confidentiality.risk != ''" class="card-body pt-0">
                    <span :qid="'risk-risk-' + riskCategory.business_risk_confidentiality.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.business_risk_confidentiality.number"
                        :class="[ riskCategory.business_risk_confidentiality.number ? 'risk-'+riskCategory.business_risk_confidentiality.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.business_risk_confidentiality.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.business_risk_confidentiality.risk)) }}
                      </span>
                      <span v-if="riskCategory.business_risk_confidentiality.number">
                        ({{riskCategory.business_risk_confidentiality.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                  <div v-if="riskCategory && riskCategory.business_risk_integrity && riskCategory.business_risk_integrity.risk != ''" class="card-body">
                    <span :qid="'risk-risk-' + riskCategory.business_risk_integrity.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.business_risk_integrity.number"
                        :class="[ riskCategory.business_risk_integrity.number ? 'risk-'+riskCategory.business_risk_integrity.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.business_risk_integrity.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.business_risk_integrity.risk)) }}
                      </span>
                      <span v-if="riskCategory.business_risk_integrity.number">
                        ({{riskCategory.business_risk_integrity.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                  <div v-if="riskCategory && riskCategory.business_risk_availability && riskCategory.business_risk_availability.risk != ''" class="card-body">
                    <span :qid="'risk-risk-' + riskCategory.business_risk_availability.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.business_risk_availability.number"
                        :class="[ riskCategory.business_risk_availability.number ? 'risk-'+riskCategory.business_risk_availability.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.business_risk_availability.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.business_risk_availability.risk)) }}
                      </span>
                      <span v-if="riskCategory.business_risk_availability.number">
                        ({{riskCategory.business_risk_availability.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedCPrivacyToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedCPrivacyToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div class="mw-500 mt-3" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedIPrivacyToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedIPrivacyToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div class="mw-500 mt-3" v-if="showToleranceRiskForm">
                  <multiselect
                      v-model="selectedAPrivacyToleranceImpact"
                      :options="impactItems"
                      :placeholder="$t('maintenance.risk_categories.risk.impact_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-impact"
                  ></multiselect>
                  <multiselect
                      v-model="selectedAPrivacyToleranceProbability"
                      :options="probabilityItems"
                      :placeholder="$t('maintenance.risk_categories.risk.probability_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="privacy-confidentiality-form-probability"
                      class="mt-2-5"
                  ></multiselect>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory && riskCategory.privacy_risk_confidentiality && riskCategory.privacy_risk_confidentiality.risk != ''" class="card-body pt-0">
                    <span :qid="'risk-risk-' + riskCategory.privacy_risk_confidentiality.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.privacy_risk_confidentiality.number"
                        :class="[ riskCategory.privacy_risk_confidentiality.number ? 'risk-'+riskCategory.privacy_risk_confidentiality.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.privacy_risk_confidentiality.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.privacy_risk_confidentiality.risk)) }}
                      </span>
                      <span v-if="riskCategory.privacy_risk_confidentiality.number">
                        ({{riskCategory.privacy_risk_confidentiality.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory && riskCategory.privacy_risk_integrity && riskCategory.privacy_risk_integrity.risk != ''" class="card-body">
                    <span :qid="'risk-risk-' + riskCategory.privacy_risk_integrity.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.privacy_risk_integrity.number"
                        :class="[ riskCategory.privacy_risk_integrity.number ? 'risk-'+riskCategory.privacy_risk_integrity.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.privacy_risk_integrity.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.privacy_risk_integrity.risk)) }}
                      </span>
                      <span v-if="riskCategory.privacy_risk_integrity.number">
                        ({{riskCategory.privacy_risk_integrity.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory && riskCategory.privacy_risk_availability && riskCategory.privacy_risk_availability.risk != ''" class="card-body">
                    <span :qid="'risk-risk-' + riskCategory.privacy_risk_availability.risk">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        v-if="riskCategory.privacy_risk_availability.number"
                        :class="[ riskCategory.privacy_risk_availability.number ? 'risk-'+riskCategory.privacy_risk_availability.number : 'risk' ]"
                      />
                      <span v-if="riskCategory.privacy_risk_availability.risk">
                        {{ $t('risk.' + $options.filters.slugify(riskCategory.privacy_risk_availability.risk)) }}
                      </span>
                      <span v-if="riskCategory.privacy_risk_availability.number">
                        ({{riskCategory.privacy_risk_availability.number}})
                      </span>
                      &nbsp;
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('maintenance.risk_categories.create.description_label') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showToleranceRiskForm">
                  <b-form-textarea
                          qid="business-risk-tolerance-description"
                          v-model="riskForm.business_risk_tolerance_description"
                          rows="6"
                          max-rows="4"
                          :placeholder="$t('maintenance.risk_categories.create.description_label')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory.business_risk_tolerance_description">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_tolerance_description}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showToleranceRiskForm">
                  <b-form-textarea
                          qid="privacy-risk-tolerance-description"
                          v-model="riskForm.privacy_risk_tolerance_description"
                          rows="6"
                          max-rows="4"
                          :placeholder="$t('maintenance.risk_categories.create.description_label')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showToleranceRiskForm">
                  <div v-if="riskCategory.privacy_risk_tolerance_description">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_tolerance_description}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters" v-if="showToleranceRiskForm">
            <div class="col-sm-2 card-menu">
            </div>
            <div class="col-sm-10">
              <div class="card-body">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="cancelToleranceFormFunction"
                            qid="risk-tolerance-form-cancel-button"
                  >
                    {{ $t('processes.legal_basis.create.cancel') }}
                  </b-button>
                  <b-button class="ml-3"
                            variant="success"
                            @click="riskToleranceFormSubmit"
                            qid="risk-tolerance-form-submit-button"
                  >
                    {{ $t('processes.legal_basis.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- If CIA risk is set on client -->
        <CiaDefinitions :category="riskCategory" v-if="getClient.risk_type == 'cia_risk'"></CiaDefinitions>

        <div class="card" qid="risk-criteria-section" v-if="getClient.risk_type != 'cia_risk'">

          <div class="card-header border-bottom-0">
            <div class="row">
              <div class="col-md-6">
                <h4 qid="risk-criteria-section-title" class="mb-3">
                  {{ $t('activities.risk_scenario.inherent_risk.risk_criteria_label') }}
                </h4>
              </div>
              <div class="col-md-6">
                <b-button
                    @click="showFormFunction"
                    v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], riskCategory.created_by) && (!getClient.parent || (getClient.parent && riskCategory.partition))"
                    variant="success"
                    class="float-right"
                    qid="edit-risk-criteria-button"
                >
                  <font-awesome-icon icon="pen"/> {{ $t('maintenance.risk_categories.update.risk_criteria_button') }}
                </b-button>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark font-weight-bold">
                <h6 class="mb-0">{{ $t('maintenance.risk_categories.risk.impact_definitions_label') }}</h6>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="text-center">
                  <h6>{{ $t('risk_scenarios.risk_type.business_risk') }}</h6>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="text-center">
                  <h6>{{ $t('risk_scenarios.risk_type.privacy_risk') }}</h6>
                </div>
              </div>
            </div>
          </div>

          <!-- Impact definitions -->
          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('impact.very_low') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_impact_very_low_definition"
                    v-model="definitionForm.business_risk_impact_very_low_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.very_low')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_impact_very_low_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_impact_very_low_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_impact_very_low_definition"
                    v-model="definitionForm.privacy_risk_impact_very_low_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.very_low')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_impact_very_low_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_impact_very_low_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('impact.low') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_impact_low_definition"
                    v-model="definitionForm.business_risk_impact_low_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.low')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_impact_low_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_impact_low_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_impact_low_definition"
                    v-model="definitionForm.privacy_risk_impact_low_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.low')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_impact_low_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_impact_low_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('impact.high') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_impact_high_definition"
                    v-model="definitionForm.business_risk_impact_high_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.high')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_impact_high_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_impact_high_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_impact_high_definition"
                    v-model="definitionForm.privacy_risk_impact_high_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.high')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_impact_high_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_impact_high_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('impact.very_high') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_impact_very_high_definition"
                    v-model="definitionForm.business_risk_impact_very_high_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.very_high')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_impact_very_high_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_impact_very_high_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_impact_very_high_definition"
                    v-model="definitionForm.privacy_risk_impact_very_high_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('impact.very_high')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_impact_very_high_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_impact_very_high_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Probability definitions -->
          <div class="row no-gutters">
            <div class="col-sm-2 card-menu pt-3 pb-3">
              <div class="card-body text-dark p-3">
                <h6 class="mb-0">{{ $t('maintenance.risk_categories.risk.probability_definitions_label') }}</h6>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black"></div>
            <div class="col-sm-5"></div>
          </div>


          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('probability.very_unlikely') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_probability_very_unlikely_definition"
                    v-model="definitionForm.business_risk_probability_very_unlikely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.very_unlikely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_probability_very_unlikely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_probability_very_unlikely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_probability_very_unlikely_definition"
                    v-model="definitionForm.privacy_risk_probability_very_unlikely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.very_unlikely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_probability_very_unlikely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_probability_very_unlikely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('probability.unlikely') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_probability_unlikely_definition"
                    v-model="definitionForm.business_risk_probability_unlikely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.unlikely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_probability_unlikely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_probability_unlikely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_probability_unlikely_definition"
                    v-model="definitionForm.privacy_risk_probability_unlikely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.unlikely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_probability_unlikely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_probability_unlikely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('probability.likely') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_probability_likely_definition"
                    v-model="definitionForm.business_risk_probability_likely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.likely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_probability_likely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_probability_likely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_probability_likely_definition"
                    v-model="definitionForm.privacy_risk_probability_likely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.likely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_probability_likely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_probability_likely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-2 card-menu">
              <div class="card-body text-dark">
                <span>{{ $t('probability.very_likely') }}</span>
              </div>
            </div>
            <div class="col-sm-5" style="border-right:1px solid black">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_business_form_probability_very_likely_definition"
                    v-model="definitionForm.business_risk_probability_very_likely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.very_likely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.business_risk_probability_very_likely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.business_risk_probability_very_likely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="card-body">
                <div class="mw-500" v-if="showRiskForm">
                  <b-form-textarea
                    qid="risk_criteria_privacy_form_probability_very_likely_definition"
                    v-model="definitionForm.privacy_risk_probability_very_likely_definition"
                    rows="6"
                    max-rows="4"
                    :placeholder="$t('probability.very_likely')"
                  ></b-form-textarea>
                </div>
                <div v-if="!showRiskForm">
                  <div v-if="riskCategory.privacy_risk_probability_very_likely_definition">
                    <p class="text-formatted"
                       qid="inherent-risk-description"
                    >
                      {{riskCategory.privacy_risk_probability_very_likely_definition}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row no-gutters" v-if="showRiskForm">
            <div class="col-sm-2 card-menu">
            </div>
            <div class="col-sm-10">
              <div class="card-body">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="cancelFormFunction"
                            qid="risk-criteria-form-cancel-button"
                  >
                    {{ $t('maintenance.risk_categories.create.cancel') }}
                  </b-button>
                  <b-button class="ml-3"
                            variant="success"
                            @click="riskFormSubmit"
                            qid="risk-criteria-form-submit-button"
                  >
                    {{ $t('maintenance.risk_categories.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </b-tab>


      <!-- Risk scenarios tab -->
      <b-tab :title="$t('maintenance.risk_categories.tab.risk_scenarios')" @click="riskScenariosTabClicked">
        <div class="card" qid="risk-section">
          <div class="card-body">

            <h5 qid="project-templates-table-title" class="mb-2">
              {{ $t('maintenance.risk_categories.tab.risk_scenarios') }}
            </h5>

            <table class="table table-responsive-md">
              <thead>
                <tr>
                  <th scope="col"
                      class="cursor-pointer"
                      @click="selectSort('name')"
                      qid="sort-s-name"
                  >
                    {{ $t('risk_scenarios.table.name') }}
                    <span class="ml-2">
                      <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                      <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                      <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                    </span>
                  </th>
                  <th scope="col">
                    {{ $t('risk_scenarios.table.owners') }}
                  </th>
                  <th scope="col">
                    {{ $t('risk_scenarios.table.category') }}
                  </th>
                  <th scope="col">
                    {{ $t('table.scope') }}
                  </th>
                  <th scope="col"
                      class="cursor-pointer"
                      @click="selectSort('updated_at')"
                      qid="sort-s-name"
                  >
                    {{ $t('system.last_updated') }}
                    <span class="ml-2">
                      <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                      <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                      <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="object in tableItems">
                  <td>
                    <router-link
                        :to="{ name: 'risk_scenarios.view', params: { slug: object.slug }}"
                        qid="s-view-page-link"
                    >
                      {{ object.name }}
                    </router-link>
                  </td>
                  <td>
                    <span v-if="object.users && object.users.length">
                      <span class="mr-1" v-for="user in object.users">
                        <span qid="profile-photo">
                          <Avatar :object="user" size="xs"></Avatar>
                        </span>
                      </span>
                    </span>
                  </td>
                  <td>
                    <span v-if="object.risk_category" class="badge badge-info mb-1">
                      {{object.risk_category.name}}
                    </span>
                  </td>
                  <td>
                    <span v-if="object.types" >
                      <span class="mr-1 badge badge-info mb-1" v-for="type in object.types">
                        {{ $t('risk_scenarios.type.' + $options.filters.slugify(type)) }}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span>
                      <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                      {{ object.updated_at | formatDate }}
                    </span>
                  </td>
                </tr>
                <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
                  <td colspan="10">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-3 pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    label="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-org-form-organization-level"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </b-tab>
    </b-tabs>


    <!-- Edit risk category modal template -->
    <b-modal ref="edit-risk-category" @hide="hideEditRCModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditRCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-rc-title">
            {{ $t('maintenance.risk_categories.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-rc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editRCFormSubmit" qid="edit-rc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-rc-name-label">
              {{ $t('maintenance.risk_categories.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-rc-form-name"
              type="text"
              v-model="rcForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.risk_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-rc-description-label">
              {{ $t('maintenance.risk_categories.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-rc-form-description"
              v-model="rcForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.risk_categories.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditRCModal"
                            qid="edit-rc-cancel-button"
                  >
                    {{ $t('maintenance.risk_categories.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="edit-rc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.risk_categories.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete risk category confirm modal template -->
    <b-modal ref="delete-risk-category" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="delete-rc-title">
            {{ $t('maintenance.risk_categories.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.risk_categories.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.risk_categories.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideConfirmDeleteModal"
                            qid="delete-rc-cancel-button"
                  >
                    {{ $t('maintenance.risk_categories.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteRC(itemToDelete)"
                            class="ml-3"
                            variant="danger"
                            qid="delete-rc-submit-button"
                            v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                  >
                    {{ $t('maintenance.risk_categories.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import CiaDefinitions from '@/views/RiskCategories/CiaDefinitions.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'RiskCategoryView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.risk_categories.title'),
          to: '/maintenance/risk-categories'
        }
      ],
      riskCategory: {},
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      itemToDelete: {},
      rcForm: {
        name: '',
        description: '',
        client:'',
      },
      error: '',
      timeLimitItems: [],
      timeLimitInput: '',
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      myGuides: [],
      descriptionLength: config.descriptionLength,
      riskForm: {
        business_risk_tolerance_description: '',
        privacy_risk_tolerance_description: '',

        business_risk_tolerance_impact: '',
        business_risk_tolerance_probability: '',
        privacy_risk_tolerance_impact: '',
        privacy_risk_tolerance_probability: '',

        business_risk_confidentiality_impact: '',
        business_risk_confidentiality_probability: '',
        privacy_risk_confidentiality_impact: '',
        privacy_risk_confidentiality_probability: '',

        business_risk_integrity_impact: '',
        business_risk_integrity_probability: '',
        privacy_risk_integrity_impact: '',
        privacy_risk_integrity_probability: '',

        business_risk_availability_impact: '',
        business_risk_availability_probability: '',
        privacy_risk_availability_impact: '',
        privacy_risk_availability_probability: '',

      },
      definitionForm: {
        business_risk_impact_very_low_definition: '',
        business_risk_impact_low_definition: '',
        business_risk_impact_high_definition: '',
        business_risk_impact_very_high_definition: '',
        business_risk_probability_very_unlikely_definition: '',
        business_risk_probability_unlikely_definition: '',
        business_risk_probability_likely_definition: '',
        business_risk_probability_very_likely_definition: '',

        privacy_risk_impact_very_low_definition: '',
        privacy_risk_impact_low_definition: '',
        privacy_risk_impact_high_definition: '',
        privacy_risk_impact_very_high_definition: '',
        privacy_risk_probability_very_unlikely_definition: '',
        privacy_risk_probability_unlikely_definition: '',
        privacy_risk_probability_likely_definition: '',
        privacy_risk_probability_very_likely_definition: '',
      },
      showRiskForm: false,
      showToleranceRiskForm: false,
      impactItems: [
        { name: this.$t('impact.very_low'), value: 'Very low' },
        { name: this.$t('impact.low'), value: 'Low' },
        { name: this.$t('impact.high'), value: 'High' },
        { name: this.$t('impact.very_high'), value: 'Very high' }
      ],
      probabilityItems: [
        { name: this.$t('probability.very_unlikely'), value: 'Very unlikely' },
        { name: this.$t('probability.unlikely'), value: 'Unlikely' },
        { name: this.$t('probability.likely'), value: 'Likely' },
        { name: this.$t('probability.very_likely'), value: 'Very likely' }
      ],

      selectedBusinessToleranceImpact: [],
      selectedBusinessToleranceProbability: [],
      selectedPrivacyToleranceImpact: [],
      selectedPrivacyToleranceProbability: [],

      selectedCBusinessToleranceImpact: [],
      selectedCBusinessToleranceProbability: [],
      selectedIBusinessToleranceImpact: [],
      selectedIBusinessToleranceProbability: [],
      selectedABusinessToleranceImpact: [],
      selectedABusinessToleranceProbability: [],

      selectedCPrivacyToleranceImpact: [],
      selectedCPrivacyToleranceProbability: [],
      selectedIPrivacyToleranceImpact: [],
      selectedIPrivacyToleranceProbability: [],
      selectedAPrivacyToleranceImpact: [],
      selectedAPrivacyToleranceProbability: [],

      showDescriptionInput: false,

      tableItems: [],
      loading: true,

      // Pagination
      perPageOptions: [
        { name: '10', value: '10' },
        { name: '20', value: '20' },
        { name: '50', value: '50' },
        { name: '100', value: '100' }
      ],
      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,
      selectedSort: '',
      selectedDirection: '',
    }
  },
  computed: {
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    getClient() {
      return this.$store.state.client
    },
    getPerPage() {
      let page = this.currentPage;
      let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
      let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
      let selectedOf = this.totalRows;

      if(selectedTo > selectedOf){
        selectedTo = selectedOf
      }

      return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      } else {
        this.loadContent();
      }
    }
  },
  components: {
    Avatar,
    CiaDefinitions,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/risk-categories')
    },
    getTask(code) {
      let existingTask = _.find(this.myTasks, function(object) {
        return object.code == code
      });
      return existingTask
    },
    openToolbar(object) {
      this.$store.commit('storeTaskToolbarState', true);
      this.$store.commit('storeActiveTask', object);
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    showDescriptionInputFunction() {
      this.showDescriptionInput = true;
      this.riskCategoryEditDescription = this.riskCategory.description;
    },
    formDescriptionSubmit() {
      let self = this;
      piincHttp.put('risk-categories/' + this.$route.params.slug, {
        description: this.riskCategoryEditDescription
      }).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.showDescriptionInput = false;
        self.$toastr('success', self.$t('maintenance.risk_categories.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    cancelDescriptionForm() {
      this.showDescriptionInput = false;
      this.riskCategoryEditDescription = this.riskCategory.description;
    },
    showFormFunction() {
      let self = this;

      this.definitionForm.business_risk_impact_very_low_definition = this.riskCategory.business_risk_impact_very_low_definition;
      this.definitionForm.business_risk_impact_low_definition = this.riskCategory.business_risk_impact_low_definition;
      this.definitionForm.business_risk_impact_high_definition = this.riskCategory.business_risk_impact_high_definition;
      this.definitionForm.business_risk_impact_very_high_definition = this.riskCategory.business_risk_impact_very_high_definition;
      this.definitionForm.business_risk_probability_very_unlikely_definition = this.riskCategory.business_risk_probability_very_unlikely_definition;
      this.definitionForm.business_risk_probability_unlikely_definition = this.riskCategory.business_risk_probability_unlikely_definition;
      this.definitionForm.business_risk_probability_likely_definition = this.riskCategory.business_risk_probability_likely_definition;
      this.definitionForm.business_risk_probability_very_likely_definition = this.riskCategory.business_risk_probability_very_likely_definition;

      this.definitionForm.privacy_risk_impact_very_low_definition = this.riskCategory.privacy_risk_impact_very_low_definition;
      this.definitionForm.privacy_risk_impact_low_definition = this.riskCategory.privacy_risk_impact_low_definition;
      this.definitionForm.privacy_risk_impact_high_definition = this.riskCategory.privacy_risk_impact_high_definition;
      this.definitionForm.privacy_risk_impact_very_high_definition = this.riskCategory.privacy_risk_impact_very_high_definition;
      this.definitionForm.privacy_risk_probability_very_unlikely_definition = this.riskCategory.privacy_risk_probability_very_unlikely_definition;
      this.definitionForm.privacy_risk_probability_unlikely_definition = this.riskCategory.privacy_risk_probability_unlikely_definition;
      this.definitionForm.privacy_risk_probability_likely_definition = this.riskCategory.privacy_risk_probability_likely_definition;
      this.definitionForm.privacy_risk_probability_very_likely_definition = this.riskCategory.privacy_risk_probability_very_likely_definition;

      this.showRiskForm = true;
    },
    showToleranceFormFunction() {
      let self = this;

      if (this.getClient.risk_type == 'cia_risk') {

        // Confidentiality

        if (this.riskCategory.business_risk_confidentiality_impact) {
          this.selectedCBusinessToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.business_risk_confidentiality_impact;
          });
        } else {
          this.selectedCBusinessToleranceImpact = []
        }

        if (this.riskCategory.business_risk_confidentiality_probability) {
          this.selectedCBusinessToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.business_risk_confidentiality_probability;
          });
        } else {
          this.selectedCBusinessToleranceProbability = []
        }

        if (this.riskCategory.privacy_risk_confidentiality_impact) {
          this.selectedCPrivacyToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_confidentiality_impact;
          });
        } else {
          this.selectedCPrivacyToleranceImpact = []
        }

        if (this.riskCategory.privacy_risk_confidentiality_probability) {
          this.selectedCPrivacyToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_confidentiality_probability;
          });
        } else {
          this.selectedCPrivacyToleranceProbability = []
        }

        /////////////////////////

        // Integrity

        if (this.riskCategory.business_risk_integrity_impact) {
          this.selectedIBusinessToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.business_risk_integrity_impact;
          });
        } else {
          this.selectedIBusinessToleranceImpact = []
        }

        if (this.riskCategory.business_risk_integrity_probability) {
          this.selectedIBusinessToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.business_risk_integrity_probability;
          });
        } else {
          this.selectedIBusinessToleranceProbability = []
        }

        if (this.riskCategory.privacy_risk_integrity_impact) {
          this.selectedIPrivacyToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_integrity_impact;
          });
        } else {
          this.selectedIPrivacyToleranceImpact = []
        }

        if (this.riskCategory.privacy_risk_integrity_probability) {
          this.selectedIPrivacyToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_integrity_probability;
          });
        } else {
          this.selectedIPrivacyToleranceProbability = []
        }

        ///////////////////////

        // Availability

        if (this.riskCategory.business_risk_availability_impact) {
          this.selectedABusinessToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.business_risk_availability_impact;
          });
        } else {
          this.selectedABusinessToleranceImpact = []
        }

        if (this.riskCategory.business_risk_availability_probability) {
          this.selectedABusinessToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.business_risk_availability_probability;
          });
        } else {
          this.selectedABusinessToleranceProbability = []
        }

        if (this.riskCategory.privacy_risk_availability_impact) {
          this.selectedAPrivacyToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_availability_impact;
          });
        } else {
          this.selectedAPrivacyToleranceImpact = []
        }

        if (this.riskCategory.privacy_risk_availability_probability) {
          this.selectedAPrivacyToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_availability_probability;
          });
        } else {
          this.selectedAPrivacyToleranceProbability = []
        }

        //////////////////

      } else {
        if (this.riskCategory.business_risk_tolerance_impact) {
          this.selectedBusinessToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.business_risk_tolerance_impact;
          });
        } else {
          this.selectedBusinessToleranceImpact = []
        }

        if (this.riskCategory.business_risk_tolerance_probability) {
          this.selectedBusinessToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.business_risk_tolerance_probability;
          });
        } else {
          this.selectedBusinessToleranceProbability = []
        }

        if (this.riskCategory.privacy_risk_tolerance_impact) {
          this.selectedPrivacyToleranceImpact = _.find(this.impactItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_tolerance_impact;
          });
        } else {
          this.selectedPrivacyToleranceImpact = []
        }

        if (this.riskCategory.privacy_risk_tolerance_probability) {
          this.selectedPrivacyToleranceProbability = _.find(this.probabilityItems, function(item) {
            return item.value === self.riskCategory.privacy_risk_tolerance_probability;
          });
        } else {
          this.selectedPrivacyToleranceProbability = []
        }
      }

      this.riskForm.business_risk_tolerance_description = this.riskCategory.business_risk_tolerance_description;
      this.riskForm.privacy_risk_tolerance_description = this.riskCategory.privacy_risk_tolerance_description;

      this.showToleranceRiskForm = true;
    },
    cancelFormFunction() {
      this.showRiskForm = false;
    },
    cancelToleranceFormFunction() {
      this.showToleranceRiskForm = false;
    },
    riskFormSubmit() {
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('risk-categories/' + this.$route.params.slug, this.definitionForm).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.buttonDisabled = false;
        self.cancelFormFunction();
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          // Attach error if exists
          self.clientForm.error = error.data.message;
        }
      })
    },
    riskToleranceFormSubmit() {
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      this.riskForm.business_risk_tolerance_impact = ''
      this.riskForm.business_risk_tolerance_probability = ''
      this.riskForm.privacy_risk_tolerance_impact = ''
      this.riskForm.privacy_risk_tolerance_probability = ''

      this.riskForm.business_risk_confidentiality_impact = ''
      this.riskForm.business_risk_confidentiality_probability = ''
      this.riskForm.privacy_risk_confidentiality_impact = ''
      this.riskForm.privacy_risk_confidentiality_probability = ''

      this.riskForm.business_risk_integrity_impact = ''
      this.riskForm.business_risk_integrity_probability = ''
      this.riskForm.privacy_risk_integrity_impact = ''
      this.riskForm.privacy_risk_integrity_probability = ''

      this.riskForm.business_risk_availability_impact = ''
      this.riskForm.business_risk_availability_probability = ''
      this.riskForm.privacy_risk_availability_impact = ''
      this.riskForm.privacy_risk_availability_probability = ''

      // CIA risks

      if (this.selectedCBusinessToleranceImpact) {
        this.riskForm.business_risk_confidentiality_impact = this.selectedCBusinessToleranceImpact.value;
      }
      if (this.selectedCBusinessToleranceProbability) {
        this.riskForm.business_risk_confidentiality_probability = this.selectedCBusinessToleranceProbability.value;
      }
      if (this.selectedCPrivacyToleranceProbability) {
        this.riskForm.privacy_risk_confidentiality_probability = this.selectedCPrivacyToleranceProbability.value;
      }
      if (this.selectedCPrivacyToleranceImpact) {
        this.riskForm.privacy_risk_confidentiality_impact = this.selectedCPrivacyToleranceImpact.value;
      }

      if (this.selectedIBusinessToleranceImpact) {
        this.riskForm.business_risk_integrity_impact = this.selectedIBusinessToleranceImpact.value;
      }
      if (this.selectedIBusinessToleranceProbability) {
        this.riskForm.business_risk_integrity_probability = this.selectedIBusinessToleranceProbability.value;
      }
      if (this.selectedIPrivacyToleranceProbability) {
        this.riskForm.privacy_risk_integrity_probability = this.selectedIPrivacyToleranceProbability.value;
      }
      if (this.selectedIPrivacyToleranceImpact) {
        this.riskForm.privacy_risk_integrity_impact = this.selectedIPrivacyToleranceImpact.value;
      }

      if (this.selectedABusinessToleranceImpact) {
        this.riskForm.business_risk_availability_impact = this.selectedABusinessToleranceImpact.value;
      }
      if (this.selectedABusinessToleranceProbability) {
        this.riskForm.business_risk_availability_probability = this.selectedABusinessToleranceProbability.value;
      }
      if (this.selectedAPrivacyToleranceProbability) {
        this.riskForm.privacy_risk_availability_probability = this.selectedAPrivacyToleranceProbability.value;
      }
      if (this.selectedAPrivacyToleranceImpact) {
        this.riskForm.privacy_risk_availability_impact = this.selectedAPrivacyToleranceImpact.value;
      }

      // Single risks

      if (this.selectedBusinessToleranceImpact) {
        this.riskForm.business_risk_tolerance_impact = this.selectedBusinessToleranceImpact.value;
      }
      if (this.selectedBusinessToleranceProbability) {
        this.riskForm.business_risk_tolerance_probability = this.selectedBusinessToleranceProbability.value;
      }
      if (this.selectedPrivacyToleranceProbability) {
        this.riskForm.privacy_risk_tolerance_probability = this.selectedPrivacyToleranceProbability.value;
      }
      if (this.selectedPrivacyToleranceImpact) {
        this.riskForm.privacy_risk_tolerance_impact = this.selectedPrivacyToleranceImpact.value;
      }

      piincHttp.put('risk-categories/' + this.$route.params.slug, this.riskForm).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.buttonDisabled = false;
        self.cancelToleranceFormFunction();
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          // Attach error if exists
          self.clientForm.error = error.data.message;
        }
      })
    },
    loadContent() {
      let self = this;
      piincHttp.get('risk-categories/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug,
        }
      }).then(function(response) {
        self.riskCategory = response.data;
        // Push content name in breadcrumb array
        self.breadcrumbItems.push({text: self.riskCategory.name, active: true});
      }, function() {});
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return require('@/assets/avatar.png');
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-risk-category'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-risk-category'].hide()
    },
    confirmDeleteRC(object) {
      let self = this;
      piincHttp.delete('risk-categories/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.risk_categories.delete.success'))
      }, function() {});
    },
    showEditRCModal(object) {
      let self = this;

      this.rcForm.slug = object.slug;
      this.rcForm.name = object.name;
      this.rcForm.description = object.description;

      this.$refs['edit-risk-category'].show()
    },
    hideEditRCModal() {
      this.timeLimitInput = ''
      this.$refs['edit-risk-category'].hide()
    },
    editRCFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.rcForm.client = this.getClient.slug;

      piincHttp.put('risk-categories/' + this.rcForm.slug, this.rcForm).then(function(response) {
        self.hideEditRCModal();
        self.buttonDisabled = false;
        // If slug is not changed, just reload content
        if (response.data.slug === self.riskCategory.slug) {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.loadContent();
        } else {
          // If slug changed, reload state with new param
          self.$router.push({ name: 'maintenance.risk_categories.view', params: { slug: response.data.slug }})
        }
        self.$toastr('success', self.$t('maintenance.risk_categories.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          // Attach error if exists
          self.error = ''
          if (error.data.errors.name) {
            self.error += ' ' + self.$t('maintenance.risk_categories.create.name_error')
          }else{
            self.error = error.data.message;
          }
        }
      })
    },
    selectSort(sort) {
      // If old and new sort are same, switch just direction
      if (sort === this.selectedSort) {
        this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
      } else {
        // If different sort, set sort and set direction to default
        this.selectedDirection = 'desc'
        this.selectedSort = sort;
      }
      this.loadRiskScenarios();
    },
    riskScenariosTabClicked() {
      this.loadRiskScenarios()
    },
    loadRiskScenarios(page, perPage) {

      // If page is not defined, set page to default 1
      let pageNumber = page ? page : 1;
      let perPageNumber = perPage ? perPage : this.selectedPerPage;
      let self = this;
      let formOwners = [];
      let formTypes = [];

      piincHttp.get('risk-scenarios', { params:
        {
          page: pageNumber,
          per_page: perPageNumber,
          risk_category: this.riskCategory.id,
          sort: this.selectedSort !== '' ? this.selectedSort : undefined,
          order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.tableItems = response.data.items;
        // Set number of total items
        self.totalRows = response.data.total_count;
      }, function() {});
    },
    pageChanged(page) {
      // Load Third parties when page changed listener is triggered
      this.loadRiskScenarios(page)
    },
    perPageChanged(perPage) {
      let self = this;
      // Load Third parties when page changed listener is triggered
      this.loadRiskScenarios(1, perPage.value)
      self.selectedPerPage = perPage.value
    },
    perPageRemoved() {
      let self = this;
      // Load Third parties when page changed listener is triggered
      self.selectedPerPage = self.perPageOptions[0].value
      this.loadRiskScenarios(1, self.selectedPerPage)
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
    }
    this.loadGuides('risk_category');
  }
}
</script>
